import Vue from "vue";

const resourceEstimate = {
  namespaced: true,
  mutations: {
    SET_ITEMS( state, payload ){
  //    state.items[ payload.id ] = Object.assign({}, state.items[ payload.id ], payload.data );
    },
    UNSET_ITEMS( state, payload ){

    },
    SET_LIST( state, payload ){

    },
    CLEAR_LIST( state, payload ){

    },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    }
  },
  actions: {
    getAutoFiltered({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        /*
        search_table_year: this.api_prm_year,
        search_table_quarter: this.api_prm_quarter,
         */
        Vue.axios.post( rootState.config.hostName + "/v1/insunetfc/autocode/filter", {
            "search_registe_date": payload.search_registe_date,
            "search_auto_company": payload.search_auto_company,
            "search_auto_name": payload.search_auto_name,
            "search_name": payload.search_name,
            "search_text": payload.search_text,
            "search_detail": payload.search_detail,
            "search_auto_type": payload.search_auto_type,
            "search_step": payload.search_step,
            "search_table_year": payload.search_table_year,
            "search_table_quarter": payload.search_table_quarter,
           } ).then( res => {
          return resolve( res );
        }).catch( reject );
      });
    },
    get({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/crm/estimate.condition", { params: { "page": 1, "size": 100, "sort": "desc", "estimate_id": payload.id } } ).then( res => {
          return resolve( res );
        })
      })
    },
    getItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        // alert(payload._id)
        Vue.axios.get( rootState.config.hostName + "/v1/www/estimates", { params:
          {
            "page": 1,
            "size": 100,
            "search_customer_id": payload._id
          }
         } ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    getAuditItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( roselve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/crm/estimate.audit/${payload.id}`).then( res => {
          return resolve( res );
        })
      })
    },
    getAutoItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/insunetfc/autocode/get/${payload.autocode}`).then( res => {
          return resolve( res );
        })
      })
    },
    getItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/www/estimate/${payload._id}`).then( res => {
          return resolve( res );
        })
      })
    },
    getCompareList({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/crm/estimate.condition.compare", { params: { "page": 1, "size": 100, "estimate_condition_id": payload.estimate_condition_id } } ).then( res => {
          return resolve( res );
        })
      })
    },
    search({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/insunetfc/autocode/list", {
          params: {
            "page": 1,
            "size": 20,
            "search_auto_type": payload.search_auto_type,
            "search_text": payload.searchText,
            "search_table_year": payload.search_table_year,
            "search_table_quarter": payload.search_table_quarter
          }
        } ).then( res => {
          return resolve ( res );
        }).catch( reject );
      })
    },
    createItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        var _params = {
          "customer_id": payload.customer_id,
          "conditions": JSON.stringify(payload)
        }
        Vue.axios.post( rootState.config.hostName + "/v1/www/estimate/create", _params).then( res => {
          if(window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                evenType: 'createEstimate',
                resMsg: '성공',
                resCode: 200,
                data: _params
              })
            );
          }
          return resolve( res );
        }).catch( reject );
      });
    },
    deleteItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.delete( /* endpoint */ ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    updateItems({ state, rootState, commit, dispatch }, payload ){
      /*var _params = {
        customer_id: payload.customer_id,
        reservation_type: payload.전화상담.step_datas.insureName.value,
        reservation_name: payload.전화상담.step_datas.name.value,
        reservation_contract: payload.전화상담.step_datas.phone.value,
        reservation_date_request: moment(payload.전화상담.step_datas.consultDate.value).format('YYYY-MM-DD') + ' ' + payload.전화상담.step_datas.consultTime.value,
        reservation_memo: payload.전화상담.step_datas.consultRemark.value,
        reservation_inflow: '홈페이지',
      }*/
      return;
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/crm/reservation/create", { request_json: payload.data } ).then( res => {
          //commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },
    createEventLog({ state, rootState, commit, dispatch }, payload) {
      return new Promise( ( resolve, reject ) => {
        var _params = {
          "customer_id": payload.customer_id,
          "estimate_id": payload.estimate_id,
        }
        Vue.axios.post( rootState.config.hostName + "/v1/www/event.log/create", _params).then( res => {
          return resolve( res );
        }).catch( reject );
      });
    }
  }

};

export default resourceEstimate;
